var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.072 3.512a4.164 4.164 0 014.164 4.164v1.61a7.511 7.511 0 001.352 4.323l.003.004.028.04a.273.273 0 01-.21.406H4.632a.272.272 0 01-.203-.403 7.511 7.511 0 001.478-4.42V7.677a4.164 4.164 0 014.165-4.164zm4.67 5.775h.506v-1.61a5.176 5.176 0 00-10.352 0V9.23a6.5 6.5 0 01-1.316 3.873 1.284 1.284 0 001.027 1.967h10.82l.029-.001a1.283 1.283 0 00.997-1.99l-.037-.053a6.5 6.5 0 01-1.168-3.738l-.506-.002zM11.505 15.828a.506.506 0 00-.7.152 1.105 1.105 0 01-.994.508 1.106 1.106 0 01-.956-.508.506.506 0 00-.851.547 2.118 2.118 0 001.816.972 2.117 2.117 0 001.837-.972.506.506 0 00-.152-.699z",
    fill: "#C4C4C4"
  })));
}
export default SvgNotificationsPage;